import { Mail } from "lucide-react";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "../../components/ui/dialog";

interface OnboardingMailConfirmModalProps {
  open: boolean;
  projectName: string;
  clientName: string;
  clientEmail: string;
  isSubmitting?: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

const OnboardingMailConfirmModal = ({
  open,
  projectName,
  clientName,
  clientEmail,
  isSubmitting = false,
  onOpenChange,
  onConfirm,
}: OnboardingMailConfirmModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md gap-6 rounded-2xl border border-gray-200 bg-white p-6 shadow-xl">
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="bg-primary/10 flex h-16 w-16 items-center justify-center rounded-full">
            <Mail className="text-primary h-8 w-8" />
          </div>

          <div className="space-y-2">
            <DialogTitle className="text-lg font-semibold text-[#111827]">
              Send Onboarding Mail?
            </DialogTitle>
            <DialogDescription className="text-muted-foreground text-sm leading-relaxed">
              The project initiation &amp; service confirmation document will be
              generated and mailed to the client.
            </DialogDescription>
          </div>

          <div className="bg-background w-full rounded-xl border border-gray-200 p-4 text-left">
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div className="space-y-0.5">
                <p className="text-muted-foreground text-xs">Project</p>
                <p className="font-semibold text-[#111827]">
                  {projectName || "--"}
                </p>
              </div>
              <div className="space-y-0.5">
                <p className="text-muted-foreground text-xs">Client</p>
                <p className="font-semibold text-[#111827]">
                  {clientName || "--"}
                </p>
              </div>
              <div className="col-span-2 space-y-0.5">
                <p className="text-muted-foreground text-xs">Send To</p>
                <p className="text-primary break-all font-medium">
                  {clientEmail || "--"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <DialogFooter className="flex gap-3 sm:justify-center">
          <Button
            type="button"
            variant="outline"
            disabled={isSubmitting}
            onClick={() => onOpenChange(false)}
            className="rounded-xl border-gray-300 bg-white px-5 hover:bg-gray-50"
          >
            Cancel
          </Button>
          <Button
            type="button"
            disabled={isSubmitting}
            onClick={onConfirm}
            className="bg-primary hover:bg-primary/90 rounded-xl px-5 text-white"
          >
            {isSubmitting ? "Sending..." : "Yes, Send Mail"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default OnboardingMailConfirmModal;
